import { useTranslation } from 'react-i18next';
import { Box } from "@mui/material";
import CustomTitleBox from "../centralComponents/CustomTitleBox";

export default function PrivacyPolicy() {
    const { t } = useTranslation();

    return (
        <CustomTitleBox title={t("privacyPolicy")} >
            <Box textAlign="center"
                dangerouslySetInnerHTML={{ __html: t('privacyPolicyText') }}
            />
        </CustomTitleBox>
    );
}